<template>
   <div class="data-picker" >
    <span v-if='!timeDefaultShow' class="near-time" @click="showData(value)">
   <span>{{value &&value[0].toString().length==1 ? optionList.filter(item=>value[0]==item.value)[0].label :''}}</span>
    <i class="el-icon-caret-bottom"></i>
    </span>

    <el-date-picker
     ref="dataPicker"
     clearable
     v-show="timeDefaultShow"
     size="mini" 
      popper-class='map-date-picker'
      v-model="upValue"
      align="center"
      type="daterange"
      unlink-panels
      placeholder="选择日期"
      range-separator="~"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions"
      :default-value="defaultValue"
      format="yyyy / MM / dd "
      value-format="timestamp"
      @change= 'change'
      @focus='onFocus'
      @blur='onBlur'
      :editable='false'
      >
    </el-date-picker>
  </div>
</template>

<script>
// import * as options from  '../../../common/optionMap';;
export default {
    props:['value','isVisible', 'isMap', 'select','constraint'],
    data() {
      return {
        value1: '',
        value2:'',
        upValue:'',
        pickerOptions: {
          shortcuts: [
            {
            text: '快捷选择',
            onClick(picker) {
               return;
              }
            },
          {
            text: '1年以内',
            onClick(picker) {
               this.value2 = "1";
               picker.$emit('pick', [this.value2]);
            }
          },{
            text: '1-5年',
             class:"ddddd",
            onClick(picker) {
              this.value2 = "2"
             
              picker.$emit('pick', [this.value2]);
            }
          }, {
            text: '5-10年',
            onClick(picker) {
               this.value2 = "3"
              picker.$emit('pick', [this.value2]);
            }
          },{
            text: '10-15年',
            onClick(picker) {
               this.value2 = "4"
              picker.$emit('pick', [this.value2]);
            }
          },{
            text: '15年以上',
            onClick(picker) {
              this.value2 = "5"
              picker.$emit('pick', [this.value2]);
            }
          }],
        },
        timeDefaultShow:null,
        optionList:options.createDateOptions,
        defaultValue:new Date().setMonth(new Date().getMonth() - 1),
        type:'monthrange'//'daterange'
      };
    },
    watch:{
     'value':{
            immediate: true,
            handler(newVal, oldVal) {
                if(newVal){
                  if(newVal[0].includes('-')){
                    const arr=newVal[0].split('-');
                    arr[0]=Number(arr[0]);
                    arr[1]=Number(arr[1]);
                    this.upValue=arr;
                    this.timeDefaultShow=true;
                  }else{
                     this.timeDefaultShow=false;
                  }
                }
            }
        },

    },
  
    mounted(){
      if(this.value &&this.value[0].length==1){
          this.timeDefaultShow=false;
      }else{
          this.timeDefaultShow=true;
      }
    },
    methods:{

        showData(value){
            this.$refs.dataPicker.focus();
            this.timeDefaultShow=true;
        },

      change(values){
        if(values && values[0].toString().length==1){
            this.$emit('change',values)
        }else{
            const arr=[];
             const str=values[0].toString()+'-'+values[1].toString();
             arr[0]=str;
            this.$emit('change',arr)
           
        }
      },

      onFocus(){
        if(this.value &&this.value[0].length==1){
            const index=Number(this.value[0])+1;
            setTimeout(() => {
            const arr=[1,2,3,4,5];
            arr.forEach(item=>document.getElementsByClassName('el-picker-panel__shortcut')[item].style.backgroundColor='#fff');
             document.getElementsByClassName('el-picker-panel__shortcut')[index].style.backgroundColor='#FFF2EA'
            }, 300);
        }
      },

      onBlur(){
        const flag=this.value &&this.value[0].length==1;
        if(flag){
            this.timeDefaultShow=false;
        }else{
            console.log(444,document.getElementsByClassName('el-picker-panel__shortcut'))
            setTimeout(()=>{
               const arr=[1,2,3,4,5];
               arr.forEach(item=>document.getElementsByClassName('el-picker-panel__shortcut')[item].style.backgroundColor='#fff');
            },200)
        }
      },
    
    },
}
</script>

<style lang="scss" scoped>
.data-picker{
    display: inline-block;
}
.near-time{
    display: inline-block;
    border: 1px solid #ccc;
    height: 26px;
    line-height: 26px;
    width: 74px;
    border-radius: 4px;
    text-align: center;
}
.block{
  // position: absolute;
  z-index:999;
  width: 250px;
}
</style>
<style lang="scss">
.el-picker-panel__shortcut{
    margin-bottom: 0 ;
    height: 28px;
    line-height: 28px;
}
</style>